import { useState, useEffect } from 'react'

export const useHttpGet = (url, callBackFnc) => {

    const [isLoading, setIsLoading] = useState(false)
    const [fetchedData, setFetchedData] = useState(null)

    const getToken = () => {
        const token = JSON.parse(localStorage.__tf_token)
        return token.id_token
    }

    const headers = {
        'Content-Type': 'application/json',
        'AuthToken': getToken()
    }

    const loadS3Data = () => {
        console.log("calling LoadS3Data", url)
        setIsLoading(true)
        fetch(`${process.env.REACT_APP_API_URL}gets3filesdata?${url}`, {
            method: 'GET',
            headers: headers
        })
            .then(response => response.json())
            .then((response) => {
                setIsLoading(false)
                setFetchedData(response);
                callBackFnc?.(response);// Call the callBackFnc
            }).catch((error) => {
                setIsLoading(false)
                console.log(error)
                if (error.message === 'Failed to fetch') {
                    window.open(process.env.REACT_APP_URL, '_self')
                }
            })
    }

    useEffect(() => {

    loadS3Data();

    }, [])

    console.log("useHttpGet isLoading", isLoading, "fetchedData  ", fetchedData);

    return [isLoading, fetchedData]
}
